import { DdiziActions } from "./DdiziActions";
import { DdiziUtils } from "./DdiziUtils";

export const DdiziState = {
  utils: DdiziUtils,
  actions: DdiziActions
}